import {environment} from '../environment/environment';
import AuthentificationService from './authentification';
import {graphql} from "graphql";

/**
 * -----------------
 * GraphQLService
 * -----------------
 * gère les requêtes graphQL
 * */
export default class GraphQLService {

    static token;

    /**
     * -------------------
     * getQuery
     * -------------------
     * allow to do a graphql request
     */
    static getQuery(query) {
        return new Promise((resolve, reject) => {
            AuthentificationService.getAnonymousToken()
                .then(function(token) {
                    GraphQLService.token = token;
                    $.ajax({
                        method: 'POST',
                        url: environment.url_api_graphql,
                        headers: {
                            'Accept': 'application/json',
                            'authorization': `Bearer ${GraphQLService.token.access_token}`,
                            'Content-Type': 'application/json',
                        },
                        data: JSON.stringify({query})
                    })
                    .success(response => {
                        resolve(response);
                    })
                    .error(error => {
                        reject(error)
                    });
                })
                .catch(function(err) {
                    console.warn(err);
                });
        });
    }

    /**
     * -----------------
     * setQueryVar
     * -----------------
     * replace variables from the query and return the modified query
     */
    static setQueryVar(query, params) {
        $.each(params, function (index, item) {
            query = query.replace(index, item);
        });
        return query;
    }
}